export default {
  loading: false,
  theme: "dark",
  myCourses: []
};
